import { render, staticRenderFns } from "./VisualizarReceita.vue?vue&type=template&id=b1e73212&"
import script from "./VisualizarReceita.vue?vue&type=script&lang=js&"
export * from "./VisualizarReceita.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarReceita.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports